import { useEffect, useState } from "react";
import { Send } from "lucide-react";
import { api } from "@/lib/api";
import { logError } from "@/lib/logger";

export const TelegramCTA = ({ className = "" }) => {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/config");
        setUrl(data.telegram_url);
      } catch (err) {
        logError("Failed to load config:", err);
      }
    })();
  }, []);

  if (!url) return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="telegram-cta"
      className={`group inline-flex items-center gap-3 border border-[#333] bg-[#141414] px-5 py-3 transition-colors hover:border-[#229ED9]/60 ${className}`}
    >
      <Send className="h-5 w-5 text-[#229ED9] transition-transform group-hover:-translate-y-0.5" strokeWidth={1.5} />
      <div className="text-left">
        <div className="font-heading text-sm text-white">Join us on Telegram</div>
        <div className="meta-label text-[#737373]">Daily declassified dossiers, first</div>
      </div>
    </a>
  );
};
